module.exports = __webpack_public_path__ + "static/media/mudeyPro_default.298c4d17.png";